<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="backUrl">
      </f7-nav-left>
      <f7-nav-title>{{ this.$f7route.query.title }}</f7-nav-title>
      <f7-nav-right>
        <f7-link
          @click="editable = !editable"
          v-show="!editable && perms.projectUpdate">
          编辑
        </f7-link>
        <f7-link @click="add" v-show="editable">保存</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <parent-header :parent="parent"></parent-header>
    <div class="has-content">
      <div v-show="!editable">
        <assist-view
          :project="project"
          :assistMaterialsDisplay="assistMaterialsDisplay"
          :workerBenefitsDisplay="workerBenefitsDisplay">
        </assist-view>
      </div>
      <f7-list inline-labels id="addAssitForm" v-show="editable">
        <f7-list-input
          label="任务名称"
          type="text"
          :value="project.name"
          @input="project.name = $event.target.value"
          placeholder="请填写"
          required
          validate
          minlength=2
          maxlength=50
          error-message='长度2-50字符'>
          <div slot="media" class="input-required">*</div>
        </f7-list-input>
        <f7-list-input
          label="工程地址"
          type="text"
          :value="project.address"
          @input="project.address = $event.target.value"
          placeholder="请填写或定位"
          minlength=2
          maxlength=100
          error-message='长度2-100字符'>
          <div slot="media" class="input-required">&nbsp;</div>
          <f7-link slot="inner-end" icon="cicon-dibiao" @click="callMap"></f7-link>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">工程规模</div>
          <div slot="input" style="display: flex;">
            <div>
              <input
                :value="project.projectSize"
                @input="project.projectSize = $event.target.value"
                type="number"
                placeholder="请填写"
                required
                validate
                min=0.00
                max=100000000.00
                step="0.01"
                data-error-message='支持两位小数'/>
            </div>
            <input
              slot="inner-end"
              type="text"
              placeholder="请选择"
              id="picker-sizeUnit"
              readonly
              required
              validate
              data-error-message='必选项'
              style="max-width: 4rem;"/>
          </div>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">任务性质</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="picker-character"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">开始日期</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="calendar-beginTime"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">结束日期</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="calendar-endTime"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">&nbsp;</div>
          <div slot="label">结算方式</div>
          <input
            slot="input"
            type="text"
            readonly
            placeholder="请选择"
            id="picker-settlement">
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">分包单价</div>
          <div slot="input" style="display: flex;">
            <div>
              <input
                type="number"
                :value="project.prePrice"
                @input="project.prePrice = $event.target.value"
                placeholder="请填写"
                required
                validate
                min=0.00
                max=100000000.00
                step="0.01"
                data-error-message='支持两位小数'/>
            </div>
            <input
              slot="inner-end"
              type="text"
              readonly
              required
              placeholder="请选择"
              id="picker-priceUnit"
              style="max-width: 5rem;"/>
          </div>
        </f7-list-input>
        <f7-list-item link="" @click="assistMaterialsPopupOpened = true">
          <div slot="media" class="input-required">&nbsp;</div>
          <div slot="inner" class="item-title item-label">辅料</div>
          <div class="item-after popup-smart-select">{{ assistMaterialsDisplay }}</div>
          <f7-popup
            :opened="assistMaterialsPopupOpened"
            @popup:closed="assistMaterialsPopupOpened = false">
            <popup-select
              title="辅料"
              :data="assistMaterialsList"
              :result.sync="project.assistMaterials">
            </popup-select>
          </f7-popup>
        </f7-list-item>
        <f7-list-item link="" @click="workerBenefitsPopupOpened = true">
          <div slot="media" class="input-required">&nbsp;</div>
          <div slot="inner" class="item-title item-label">福利待遇</div>
          <div class="item-after popup-smart-select">{{ workerBenefitsDisplay }}</div>
          <f7-popup
            :opened="workerBenefitsPopupOpened"
            @popup:closed="workerBenefitsPopupOpened = false">
            <popup-select
              title="福利待遇"
              :data="workerBenefitsList"
              :result.sync="project.workerBenefits">
            </popup-select>
          </f7-popup>
        </f7-list-item>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">&nbsp;</div>
          <div slot="label">质量标准</div>
          <input
            slot="input"
            type="text"
            readonly
            placeholder="请选择"
            id="picker-qualityStandard">
        </f7-list-input>
        <f7-list-input
          label="任务说明"
          type="textarea"
          :value="project.projectRemark"
          @input="project.projectRemark = $event.target.value"
          placeholder="请填写"
          validate
          maxlength=500
          error-message='长度0-500字符'
          resizable>
          <div slot="media" class="input-required">&nbsp;</div>
        </f7-list-input>
      </f7-list>
    </div>
  </f7-page>
</template>
<script>
import Vue from 'vue';
import lodash from 'lodash';
import { toGaodeMap } from '@/util/native';
import { createPicker, createCalendar, createToast } from '@/util/compUtils';
import { dateFormat } from '@/util/dateUtils';
import { getDict } from '@/api/common';
import { getAssistView, splitAssistProject, updateSplitAssistProject, splitProjectInfo } from '@/api/project/project';
import { getComanyList } from '@/api/team/worker';
import { AssistProject } from '@/model/reqObject';
import PopupSelect from '@/components/PopupSelect';
import ParentHeader from '@/components/ParentHeader';
import AssistView from '@/components/AssistView';

export default {
  props: ['projectId'],
  components: {
    PopupSelect,
    ParentHeader,
    AssistView,
  },
  data() {
    return {
      editable: lodash.isEmpty(this.projectId),
      parent: {},
      projectCharacterList: [],
      projectSettlementList: [],
      projectSizeUnitList: [],
      qualityStandardList: [],
      assistMaterialsList: [],
      workerBenefitsList: [],
      project: new AssistProject(),
      assistMaterialsPopupOpened: false,
      workerBenefitsPopupOpened: false,
      perms: {},
    };
  },
  created() {
    window.setAssistAddress = this.setAssistAddress;
  },
  mounted() {
    const dictKeys = [
      'projectCharacter', 'projectSettlement', 'projectSizeUnit', 'priceUnit',
      'assistMaterials', 'workerBenefits', 'qualityStandard',
    ];
    Promise.all([
      getDict({ typeCodes: dictKeys }).then((result) => {
        this.projectCharacterList = result.data.projectCharacter.codeVoList || [];
        this.projectSizeUnitList = result.data.projectSizeUnit.codeVoList || [];
        this.projectSettlementList = result.data.projectSettlement.codeVoList || [];
        this.priceUnitList = result.data.priceUnit.codeVoList || [];
        this.assistMaterialsList = result.data.assistMaterials.codeVoList || [];
        this.workerBenefitsList = result.data.workerBenefits.codeVoList || [];
        this.qualityStandardList = result.data.qualityStandard.codeVoList || [];
      }),
      getComanyList().then((result) => {
        this.companyList = result.data || [];
      }),
      splitProjectInfo({
        projectId: this.$f7route.query.parentId,
      }).then((result) => {
        this.parent = result.data || {};
      }),
    ]).then(() => this.getInfo());
  },
  computed: {
    backUrl() {
      if (lodash.isEmpty(this.projectId)) {
        return `/project/tree/${this.$f7route.query.rootId}`;
      }
      return `/project/info/${this.projectId}?rootId=${this.$f7route.query.rootId}`;
    },
    assistMaterialsDisplay() {
      return this.assistMaterialsList
        .filter(item => this.project.assistMaterials.includes(item.code))
        .map(item => item.name)
        .join(', ');
    },
    workerBenefitsDisplay() {
      return this.workerBenefitsList
        .filter(item => this.project.workerBenefits.includes(item.code))
        .map(item => item.name)
        .join(', ');
    },
  },
  methods: {
    callMap() {
      toGaodeMap(
        this.project.address || '',
        this.project.lat || '',
        this.project.lag || '', 'setAssistAddress');
    },
    setAssistAddress(address, lat, lag) {
      Vue.set(this.project, 'address', address || '');
      Vue.set(this.project, 'lat', lat || '');
      Vue.set(this.project, 'lag', lag || '');
    },
    getInfo() {
      if (!lodash.isEmpty(this.projectId)) {
        getAssistView({ projectId: this.projectId }).then((result) => {
          this.project = result.data || {};
          this.init();
          this.perms = result.perms || {};
        });
      } else {
        this.init();
      }
    },
    setErrorMsg(elem) {
      elem.addClass('input-invalid');
      let tmpNode = elem;
      while (this.$$(tmpNode).parent() && this.$$(tmpNode).parent().length !== 0) {
        if (tmpNode.hasClass('item-content')) {
          tmpNode.addClass('item-input-with-error-message');
          tmpNode.addClass('item-input-invalid');
          break;
        } else {
          tmpNode = this.$$(tmpNode).parent();
        }
      }
    },
    add() {
      // this.$f7.input.validateInputs('#addAssitForm');
      if (lodash.isEmpty(this.project.projectCharacter)) {
        this.setErrorMsg(this.$$('#picker-character'));
      }
      if (lodash.isEmpty(this.project.planStartupTime)) {
        this.setErrorMsg(this.$$('#calendar-beginTime'));
      }
      if (lodash.isEmpty(this.project.planCompletedTime)) {
        this.setErrorMsg(this.$$('#calendar-endTime'));
      }
      if (lodash.isEmpty(this.project.sizeUnit)) {
        this.setErrorMsg(this.$$('#picker-sizeUnit'));
      }
      // if (lodash.isEmpty(this.project.settlement)) {
      //   this.setErrorMsg(this.$$('#picker-settlement'));
      // }
      if (lodash.isEmpty(this.project.priceUnit)) {
        this.setErrorMsg(this.$$('#picker-priceUnit'));
      }
      if (!lodash.gte(this.project.planCompletedTime, this.project.planStartupTime)) {
        createToast(this, '结束日期必须大于等于开始日期');
        return;
      }
      if (!lodash.gte(this.project.planStartupTime, dateFormat(this.parent.startupTime))) {
        createToast(this, '开始日期必须大于等于上级任务的开始日期');
        return;
      }
      if (!lodash.lte(this.project.planCompletedTime, dateFormat(this.parent.completedTime))) {
        createToast(this, '结束日期必须小于等于上级任务的结束日期');
        return;
      }
      let valided = true;
      this.$$('#addAssitForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      if (!valided) {
        return;
      }
      let action = updateSplitAssistProject;
      let params = Object.assign(
        this.project,
        { parentId: this.project.parentId || this.$f7route.query.parentId },
      );
      if (lodash.isEmpty(this.projectId)) {
        action = splitAssistProject;
        params = Object.assign(
          params,
          { projectId: this.project.parentId || this.$f7route.query.parentId },
        );
      }
      if (!lodash.isEmpty(this.$f7route.query.preProjectId)) {
        params = Object.assign(
          params,
          { preProjectId: this.project.preProjectId || this.$f7route.query.preProjectId },
        );
      }
      action(params).then((data) => {
        if (data.code === 0) {
          let opt = '添加';
          if (!lodash.isEmpty(this.projectId)) {
            opt = '修改';
          }
          createToast(this, `${opt}辅助任务成功`);
          this.$f7router.back(this.backUrl);
        }
      });
    },
    init() {
      createPicker(
        this,
        '#picker-character',
        this.projectCharacterList.map(d => d.code),
        this.projectCharacterList.map(d => d.name),
        'project',
        'projectCharacter',
      );
      createCalendar(this, '#calendar-beginTime', 'project', 'planStartupTime');
      createCalendar(this, '#calendar-endTime', 'project', 'planCompletedTime');
      createPicker(
        this,
        '#picker-sizeUnit',
        this.projectSizeUnitList.map(d => d.code),
        this.projectSizeUnitList.map(d => d.name),
        'project',
        'sizeUnit',
      );
      createPicker(
        this,
        '#picker-settlement',
        this.projectSettlementList.map(d => d.code),
        this.projectSettlementList.map(d => d.name),
        'project',
        'settlement',
      );
      createPicker(
        this,
        '#picker-priceUnit',
        this.priceUnitList.map(d => d.code),
        this.priceUnitList.map(d => d.name),
        'project',
        'priceUnit',
      );
      createPicker(
        this,
        '#picker-qualityStandard',
        this.qualityStandardList.map(d => d.code),
        this.qualityStandardList.map(d => d.name),
        'project',
        'qualityStandard',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .parent-area {
    background-color: $panel-bg-color;
  }

  .parent-name {
    text-align: center;
    padding: 0.5rem 0.5rem;
  }

  .parent-name-text {
    display: inline-block;
    text-align: left;
  }

  .parent-scope {
    text-align: center;
    padding: 0.5rem 0.5rem;
  }

  .parent-scope-text {
    display: inline-block;
    text-align: left;
    color: $second-font-color;
    font-size: 0.9rem;
  }

  .popup-smart-select {
    max-width: 63%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  input.input-invalid::placeholder {
    color: #ff3b30;
  }

  .input-required {
    padding-left: 0.5rem;
    padding-top: 0.4rem;
    color: #FF0000;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/project/addAssist.vue